<template>
  <div class="page dataList">
    <div class="p16">
      <p style="font-weight: bold;">电子总账<span class="moneys fontSize14">（数据指标可能存在几分钟延迟）</span></p>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box">
          <div class="boxs br10">
            <div class="titles">
              <p class="order-title-boxs"><span class="blueBlock"></span><i>数据汇总</i></p>
              <v-date @time="change" class="ml10"></v-date>
            </div>
            <el-row class="rows">
              <el-col class="cols" :span="4">
                <p class="van-text">会员充值</p>
                <p class="van-label">{{amount.rechargeAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">充值赠送</p>
                <p class="van-label">{{amount.rechargeGiveAmountSum}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">现金购买套餐</p>
                <p class="van-label">{{amount.cardSaleAmountCash}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">消费金额</p>
                <p class="van-label">{{amount.itemConsumeAchAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">提现解冻</p>
                <p class="van-label">{{amount.withdrawAndFreezeAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">提现提现解冻</p>
                <p class="van-label">{{amount.withdrawAndFreezeGiveAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">应收店面</p>
                <p class="van-label">{{amount.shouldCollectAmount}}</p>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";

export default {
  mixins: [minxin],
  data() {
    return {
      amount: {},
      downloadUrl: require("../../../assets/images/home/data.png"),
      amountBO: {},
      paywaySetBOList: [],
      invoiceBOList: [],
      orderItemSumBOList: [],
      query: {
        beginTime: new Date(),
        endTime: new Date()
      }
    };
  },
  components: {},
  created() {
    
  },
  methods: {
    back() {
      this.$router.push('/dataList');
    },
    change(value) {
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
      this.pageDetailByShop();
    },
    pageDetailByShop() {
      this.$api
        .post(this.$url.reportElectronMember.summary, {
          beginTime: this.query.beginTime,
          endTime: this.query.endTime
        })
        .then(res => {
          this.amount = res;
        })
        .catch(error => {
          this.error = true;
        });
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
* {
  box-sizing: border-box;
}
.mains-content {
  height: calc(100% - 72px);
}
</style>